import { fadeIn } from '@pernod-ricard-global-cms/jsanimations';
import { loadCss } from "v-js-utils";
import {createApp} from 'vue';
import MagazineIssueGrid from 'Assets/vue/blocks/magazine-issue-grid.vue';

export default function magazineissuegridJs ( options = {} ) {
	try {
		const { block } = options;
		loadCss(block.dataset.assetkey, options).then(() => {
			const mountElement = block.children[0];
			createApp(MagazineIssueGrid, {...mountElement.dataset}).mount(mountElement);
			fadeIn(block);
		});
	} catch ( error ) {
		console.error( error );
	}
}